<div
  *ngIf="tipsAllowed$ | async"
  class="mb-3 px-5 lg:px-0 max-w-md lg:max-w-full mx-auto"
>
  <app-cart-tip-atom
    [choice1Amount]="choice1Amount"
    [choice1Unit]="choice1Unit"
    [choice2Amount]="choice2Amount"
    [choice2Unit]="choice2Unit"
    [choice3Amount]="choice3Amount"
    [choice3Unit]="choice3Unit"
    [totalAmount]="(totalAmount$ | async) / 100"
    (tipEmitter)="onSelectedTip($event)"
  ></app-cart-tip-atom>
</div>
